export default __webpack_public_path__ + "static/media/Second.06728c9e.png";